import React, { useState } from "react";
import AnimatedButton from "../components/AnimatedButton";
import emailjs from "@emailjs/browser";

function Contact() {
  const [formData, setFormData] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });
  const [status, setStatus] = useState("");

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.id]: e.target.value });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setStatus("Sending...");

    emailjs
      .send(
        "service_vydy57d",
        "template_90xz6eo",
        formData,
        "QEbjBqO2un94y69Yj"
      )
      .then(
        (response) => {
          setStatus("Message sent successfully!");
          setFormData({ name: "", email: "", phone: "", message: "" });
        },
        (error) => {
          console.error(error);
          setStatus("Failed to send message.");
        }
      );
  };
  return (
    <div className="contact-page">
      {/* Banner Section */}
      <section className="about-banner position-relative overflow-hidden">
        <div className="container position-relative z-index-1">
          <div className="row align-items-center">
            <div className="col-lg-12 text-center">
              <h1 className="display-5 fw-bold mb-4">Get In Touch</h1>
              <p>
                We're always ready to help with your facility management needs.
                Reach out to us for inquiries, quotes, or support.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Content */}
      <section className="contact-content py-5 bg-light">
        <div className="container">
          <div className="row g-5">
            <div className="col-lg-6">
              <div className="contact-info p-4 p-lg-5 rounded-3 bg-white">
                <h2 className="fw-bold mb-">Our Contact Information</h2>
                <p className="mb-5 text-muted">
                  Whether you have questions about our services or need
                  immediate assistance, our team is here to help you.
                </p>

                <div className="contact-details">
                  <div className="detail-item mb-4 d-flex">
                    <div className="icon-box bg-primary text-white rounded-circle me-4">
                      <i className="fas fa-map-marker-alt"></i>
                    </div>
                    <div>
                      <h3 className="h5 fw-bold mb-2">Office Address</h3>
                      <p className="mb-0 text-muted">
                        Near Muralidhar Hotel, Narayan Peth, Pune, Maharashtra,
                        India
                      </p>
                    </div>
                  </div>

                  <div className="detail-item mb-4 d-flex">
                    <div className="icon-box bg-primary text-white rounded-circle me-4">
                      <i className="fas fa-phone"></i>
                    </div>
                    <div>
                      <h3 className="h5 fw-bold mb-2">Phone</h3>
                      <p className="mb-0 text-muted">
                        +91 9822738807 / +91 8007138807
                      </p>
                    </div>
                  </div>

                  <div className="detail-item mb-4 d-flex">
                    <div className="icon-box bg-primary text-white rounded-circle me-4">
                      <i className="fas fa-envelope"></i>
                    </div>
                    <div>
                      <h3 className="h5 fw-bold mb-2">Email</h3>
                      <p className="mb-0 text-muted">rrfms1@gmail.com</p>
                    </div>
                  </div>

                  <div className="detail-item d-flex">
                    <div className="icon-box bg-primary text-white rounded-circle me-4">
                      <i className="fas fa-clock"></i>
                    </div>
                    <div>
                      <h3 className="h5 fw-bold mb-2">Working Hours</h3>
                      <p className="mb-2 text-muted">
                        Monday to Saturday: 9:00 AM – 6:00 PM
                      </p>
                      <p className="mb-0 text-muted">Sunday: Closed</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="col-lg-6">
              <div className="contact-form p-4 p-lg-5 rounded-3 bg-white">
                <h2 className="h3 fw-bold mb-2">Send Us a Message</h2>
                <p className="mb-3 text-muted">Fill out the form below</p>

                <form onSubmit={handleSubmit}>
                  <div className="form-floating mb-3">
                    <input
                      type="text"
                      className="form-control"
                      id="name"
                      placeholder="Your name"
                      value={formData.name}
                      onChange={handleChange}
                      required
                    />
                    <label htmlFor="name">Name*</label>
                  </div>

                  <div className="form-floating mb-3">
                    <input
                      type="email"
                      className="form-control"
                      id="email"
                      placeholder="your.email@example.com"
                      value={formData.email}
                      onChange={handleChange}
                      required
                    />
                    <label htmlFor="email">Email*</label>
                  </div>

                  <div className="form-floating mb-3">
                    <input
                      type="tel"
                      className="form-control"
                      id="phone"
                      placeholder="+91 XXXXXXXXXX"
                      value={formData.phone}
                      onChange={handleChange}
                    />
                    <label htmlFor="phone">Phone Number</label>
                  </div>

                  <div className="form-floating mb-4">
                    <textarea
                      className="form-control"
                      id="message"
                      placeholder="How can we help you?"
                      style={{ height: "150px" }}
                      value={formData.message}
                      onChange={handleChange}
                      required
                    ></textarea>
                    <label htmlFor="message">Message*</label>
                  </div>

                  <AnimatedButton
                    text="Send Message"
                    type="submit"
                    className="w-100 py-3"
                  />
                  {status && <p className="mt-3 text-center">{status}</p>}
                </form>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Contact;
